export default __webpack_public_path__ + "static/media/63t.fbddaad6.jpg";